import './EditionPage.scss';
import { SimpleNumberCard } from '@design-system/index';
import { CotisationsLine } from '@icons';
import { MutationTable } from '@components/Table/MutationTable/MutationTable';
import { ColumnDef } from '@tanstack/react-table';
import { useContributionEditionPageVM } from './useEditionPageVM';
import { Contribution } from '@services/member/contribution/contribution.types';
import { useGetContributionsEditionMutation, useGetContributionsExportMutation } from '@services/member/contribution/contribution.endpoints';
import { formatDate } from '@utils/dates';
import { formatMoney } from '@utils/numbers';

export default function ContributionEditionPage() {
    const {
        handleMetadata,
        columnHelper,
        totalContributions
    } = useContributionEditionPageVM();

    const columns = [
        columnHelper.accessor((row) => row.member.cosemNumber, {
            header: 'N° COSEM',
            id: 'member.cosemNumber',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.member.personalInformation.lastname + ' ' + row.member.personalInformation.firstname, {
            header: 'Adhérent',
            id: 'member.personalInformation.lastname',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.member.administrativeInformation.stateCodeLabel, {
            header: 'Code état',
            id: 'member.administrativeInformation.stateCode',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.year, {
            header: 'Année',
            id: 'year',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.dateContributed, {
            header: 'Date de paiement',
            id: 'dateContributed',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue() ? formatDate(info.getValue() as string) : ''}</>
        }),
        columnHelper.accessor((row) => row.amount, {
            header: 'Montant',
            id: 'amount',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{formatMoney(info.getValue())}</>
        }),
        columnHelper.accessor((row) => row.observation, {
            header: 'Commentaire',
            id: 'observation',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.isArchived, {
            id: 'isArchived',
            header: 'Archivé',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{info.getValue() ? 'Oui' : 'Non'}</>
        })
    ] as ColumnDef<Contribution>[];

    return (
        <div className="members-table-container">
            <div className="members-table-container-header">
                <div className="members-table-container-header-left">
                    <SimpleNumberCard
                        labelForSingle={'Cotisation'}
                        labelForMultiple={'Cotisations'}
                        value={totalContributions}
                    />
                </div>
            </div>
            <MutationTable
                key={'edition'}
                columns={columns}
                selectable={false}
                mutationHook={useGetContributionsEditionMutation}
                defaultSorting={{
                    field: 'createdAt',
                    direction: 'desc'
                }}
                exportable={true}
                exportMutationHook={useGetContributionsExportMutation}
                headerTitle={'Édition cotisations'}
                headerIcon={<CotisationsLine />}
                headerIconColor="green-water"
                onMetadata={handleMetadata}
                filters={[
                    {
                        id: 'dateContributed',
                        label: 'Date de paiement',
                        type: 'date',
                        comparatorTypes: ['isBetween', 'isBefore', 'isAfter', 'equals']
                    },
                    {
                        id: 'year',
                        label: 'Année',
                        type: 'string',
                    },
                    {
                        id: 'isArchived',
                        label: 'Archivé',
                        type: 'boolean'
                    }
                ]}
            />
        </div>
    );
}
